













import Vue from 'vue';

export default Vue.extend({
  name: 'HomeView',
  head: {
    title: {
      inner: 'Home',
    },
  },
});
